module.exports = __webpack_public_path__ + "static/landsatta-responsive-4a6da54e42de6b595687b3a590f19f27.png";